import { AfterViewInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { properties } from '../../../../environments/properties';
import { SubscriptionService } from "../../../shared/services/subscription.service";

declare let $: any;
declare let AB: any;

@Component({
  selector: 'app-current-plan',
  templateUrl: './current-plan.component.html',
  styleUrls: ['./current-plan.component.scss']
})
export class CurrentPlanComponent {

  @Input() userSubscriptionDetails: any;
  @Input() userInfo: any;
  @Input() tenderInfo;
  @Input() currentEnvironment;
  @Input() showTenders;

  subscriptionType: any;
  hasPendingSubscription: any;
  pricingDetail: any;
  subSummaryTitle: string = '';
  showChangePlanLink = false;
  showCanNotChangePlanText = false;

  properties = properties;
  enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
  programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

  snapFlagEnabled: boolean = properties.featureFlags.enableSnap;
  isSnapPlan: boolean = false;
  SNAP_KEY: string = this.programDisplayData?.freshpassData?.snapKey;
  pleaseReverifyEligibilityText: string = this.programDisplayData?.freshpassData?.pleaseReverifyEligibilityText;
  govAssistanceElibilityText: string = this.programDisplayData?.freshpassData?.govAssistanceElibilityText;
  freeTrialTitle: string = this.programDisplayData?.freshpassData?.freeTrialTitle;
  showCancelFpPlanLink: boolean = true;
  currentPlanIcon: string = this.programDisplayData?.manage?.CURRENT_PLAN_ICON;

  renewalDateDisplay: string = '';
  currentPlanExpiryDateDisplay: string = '';
  pendingRenewalDateDisplay: string = '';

  subscriptionTypeText: string = '';
  subscriptionEndDateText: string = '';
  subscriptionTypeDetails: string = '';
  renewalCostText: string = '';
  freeTrialEndDateText: string = '';
  showSubscriptionEndDate: boolean = true;
  
  planType: string = '';
  pendingPlanType: string = '';
  isTrialPlan: boolean = false;

  constructor(
    private router: Router,
    public subscriptionService: SubscriptionService,
  ) {
  }

  ngOnInit() {
    if (this.userSubscriptionDetails) {
      this.hasPendingSubscription = this.userSubscriptionDetails?.pendingSubscriptionType ? true : false;
      this.getPlanType();
      this.getTrialPlanStatus(this.userSubscriptionDetails);
      this.setConvertedDisplayDate();
      this.checkAndSetSnapPlan();
      this.setSubSummaryTitle(this.userSubscriptionDetails);
      this.setFreeTrialEndDateText();
      this.setSubscriptionTypeText(this.userSubscriptionDetails);
      this.setSubscriptionCostText(this.userSubscriptionDetails);
      this.handleSubscriptionStatus();
    }
  }

  checkAndSetSnapPlan(): void {
    if (this.userSubscriptionDetails) {
      this.isSnapPlan = this.userSubscriptionDetails?.discountType?.toLowerCase().includes(this.SNAP_KEY);
    }
  }

  handleSubscriptionStatus(): void {
    this.handlePendingCancellationMessage();
    this.handleChangePlanLinkVisibility();
    this.handleSuspendedStatus();
    this.handlePendingActivationStatus();
    this.handleProcessingStatus();
    this.handleChangePlanConStatus();
    this.handleCancelPlanLinkVisibility();
  }

  setConvertedDisplayDate(): void {
    if (this.userSubscriptionDetails?.curentPlanExpiryDate) {
      this.currentPlanExpiryDateDisplay = this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate);
    }
    if (this.userSubscriptionDetails?.renewalDate) {
      this.renewalDateDisplay = this.subscriptionService.convertDate(this.userSubscriptionDetails?.renewalDate);
    }
    if (this.userSubscriptionDetails?.pendingRenewalDate) {
      this.pendingRenewalDateDisplay = this.subscriptionService.convertDate(this.userSubscriptionDetails?.pendingRenewalDate);
    }
  }

  handleChangePlanLinkVisibility(): void {
    this.showChangePlanLink = this.userSubscriptionDetails?.isPlanChangeAvailable;
  }

  handlePendingCancellationMessage(): void {
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_CANCELLATION) {
      this.subscriptionEndDateText = this.programDisplayData?.manage?.CURRENT_PLAN_ENDS_MSG?.replace('{expiryDate}', this.currentPlanExpiryDateDisplay) || '';
    } else {
      if (this.isTrialPlan) {
        this.subscriptionEndDateText = this.programDisplayData?.manage?.CURRENT_PLAN_BEGINS_MSG?.replace('{planType}', this.planType)?.replace('{renewalDate}', this.renewalDateDisplay) || '';
      } else {
        this.subscriptionEndDateText = this.programDisplayData?.manage?.CURRENT_PLAN_RENEWS_MSG?.replace('{renewalDate}', this.renewalDateDisplay) || '';
      }
      this.checkAndUpdateRetentionSubscriptinEndDateMessage();
    }
  }

  handleSuspendedStatus(): void {
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.SUSPENDED?.toUpperCase() 
      || ((this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_ACTIVATION) && (this.userSubscriptionDetails?.status === this.programDisplayData?.manage?.SUSPENDED))) {
      this.showSubscriptionEndDate = false;
    }
  }

  handlePendingActivationStatus(): void {
    if ((this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_ACTIVATION) && (this.userSubscriptionDetails?.status != this.programDisplayData?.manage?.SUSPENDED)) {
      if (this.userSubscriptionDetails?.pendingRenewalDate && this.userSubscriptionDetails?.pendingFee && this.userSubscriptionDetails?.pendingSubsCode) {
        const addDiscountLabel = this.getDiscountLabel();
        if (addDiscountLabel) {
          this.subscriptionEndDateText = this.programDisplayData?.manage?.DISCOUNT_PLAN_BEGINS_MSG?.replace('{discounted}', addDiscountLabel)?.replace('{planType}', this.userSubscriptionDetails.pendingSubscriptionType.toLowerCase())?.replace('{renewalDate}', this.renewalDateDisplay) || '';
        } else {
          this.subscriptionEndDateText = this.programDisplayData?.manage?.PLAN_BEGINS_MSG?.replace('{planType}', this.pendingPlanType)?.replace('{renewalDate}', this.renewalDateDisplay) || '';
        }
      }
    }
  }

  handleProcessingStatus(): void {
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PROCESSING) {
      if (this.userSubscriptionDetails?.renewalDate && this.userSubscriptionDetails?.fee && this.userSubscriptionDetails?.subscriptionCode) {
        this.subscriptionEndDateText = this.programDisplayData?.manage?.PLAN_BEGINS_MSG?.replace('{planType}', this.planType)?.replace('{renewalDate}', this.renewalDateDisplay) || '';
      }
    }
  }

  handleChangePlanConStatus(): void {
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.CHANGE_PLAN_CON) {
      this.showCanNotChangePlanText = true;
    }
  }

  handleCancelPlanLinkVisibility(): void {
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_CANCELLATION
      || this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.CANCELLED) {
      this.showCancelFpPlanLink = false;
    }
  }

  checkAndUpdateRetentionSubscriptinEndDateMessage() {
    if (this.userSubscriptionDetails?.pendingDiscountType?.toLowerCase() === this.programDisplayData?.prechurn?.retentionDiscountType) {
      this.subscriptionEndDateText = this.programDisplayData?.prechurn?.discountPlanBeginsMessage?.replace('{pendingSubscriptionType}', this.userSubscriptionDetails?.pendingSubscriptionType?.toLowerCase())?.replace('{renewalDate}', this.renewalDateDisplay) || '';
    }
  }
  getDiscountLabel() {
    const isPendingRetentionDiscount = this.userSubscriptionDetails?.pendingDiscountType?.toLowerCase() === this.programDisplayData?.prechurn?.retentionDiscountType;
    return isPendingRetentionDiscount ? 'Discounted ' : '';
  }

  getTrialPlanStatus(data) {
    if (data) {
      if ((data?.status?.toLowerCase() === this.programDisplayData?.manage?.TRIAL?.toLowerCase()) || (data?.status?.toLowerCase() === this.programDisplayData?.manage?.PROCESSING?.toLowerCase() && data?.previousStatus?.toLowerCase() === this.programDisplayData?.manage?.TRIAL?.toLowerCase())) {
        this.isTrialPlan = true;
      } else {
        this.isTrialPlan = false;
      }
    }
  }

  goToChangePlan() {
    this.router.navigate([this.programDisplayData?.urlPath?.CHANGE_PLAN_PATH], { state: { userSubscriptionDetails: this.userSubscriptionDetails, isRedirectedFromManageLink: true } });
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB'].DATALAYER.analyticsSetLSFPUpdate('upgradeBtn', this.userSubscriptionDetails?.subscriptionStatus);
      window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('change', {});
    }
  }

  setSubSummaryTitle(data) {
    const subscriptionType = data?.subscriptionType;
    this.subSummaryTitle = subscriptionType || '';
  }

  setFreeTrialEndDateText() {
    if (this.isTrialPlan) {
      this.freeTrialEndDateText = this.programDisplayData?.manage?.FREE_TRIAL_ENDS_ON_MSG?.replace('{currentPlanExpiryDate}', this.currentPlanExpiryDateDisplay) || '';
    } else {
      this.freeTrialEndDateText = '';
    }
  }

  setSubscriptionTypeText(data) {
    if (this.isTrialPlan) {
      this.subscriptionTypeText = this.programDisplayData?.manage?.FREE_TRIAL || '';
    } else if (data?.subscriptionType?.toLowerCase()?.indexOf(this.programDisplayData?.manage?.MONTHLY?.toLowerCase()) >= 0) {
      this.subscriptionTypeText = this.programDisplayData?.manage?.MONTHLY_SUBSCRIBER || '';
    } else {
      this.subscriptionTypeText = this.programDisplayData?.manage?.ANNUAL_SUBSCRIBER || '';
    }
  }

  setPendingCostDetails(data, currentPrice) {
    if (this.userSubscriptionDetails?.subscriptionStatus !== this.programDisplayData?.manage?.PENDING_CANCELLATION){
      let pendingPricingDetail = this.subscriptionService.getPricingDetail(data?.pendingPricingDetail, data?.subscriptionType);
      let pricingDetail = this.subscriptionService.getPricingDetail(data?.pricingDetail, data?.subscriptionType);
  
      if (this.isTrialPlan) {
        if (data?.pendingDiscountType?.toLowerCase() === this.programDisplayData?.prechurn?.retentionDiscountType && data?.pendingFee && data?.pendingPricingDetail) {
          this.subscriptionTypeDetails = '';
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_PENDING_FEE?.replace('{pendingFee}', data?.pendingFee)?.replace('{pendingPricingDetails}', pendingPricingDetail) || '';
        } else {
          this.subscriptionTypeDetails = '';
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_PENDING_FEE_TAX?.replace('{pendingFee}', data?.pendingFee)?.replace('{pendingPricingDetails}', pendingPricingDetail) || '';
        }
      } else {
        this.subscriptionTypeDetails = this.programDisplayData?.manage?.CURRENT_PLAN_UNTIL_EXPIRY_DATE?.replace('{currentPrice}', currentPrice)?.replace('{pricingDetail}', pricingDetail)?.replace('{currentExpiryDate}', this.currentPlanExpiryDateDisplay) || '';
        if (data?.pendingPricingDetail?.includes(this.programDisplayData?.freshpassData?.forTheFirstYearText)) {
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_PENDING_FEE_FOR_FIRST_YEAR?.replace('{pendingFee}', data?.pendingFee)?.replace('{pendingPricingDetails}', pendingPricingDetail) || '';
        } else {
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_PENDING_FEE?.replace('{pendingFee}', data?.pendingFee)?.replace('{pendingPricingDetails}', pendingPricingDetail) || '';
        }
      }
    }
  }

  setSubscriptionCostText(data) {
    let pricingDetail = this.subscriptionService.getPricingDetail(data?.pricingDetail, data?.subscriptionType);
    let isPendingAnnualPlan = (data?.pendingSubscriptionType === this.programDisplayData?.manage?.ANNUAL_PLAN) ? true : false;
    let isPendingMonthlyPlan = (data?.pendingSubscriptionType === this.programDisplayData?.manage?.MONTHLY_PLAN) ? true : false;
    let isMonthlyPlan = (data?.subscriptionType?.toLowerCase()?.indexOf(this.programDisplayData?.manage?.MONTHLY?.toLowerCase()) >= 0) ? true : false;
    let currentPrice = data?.fee;
    let isSnapUser = data?.discountType && data?.discountType?.toLowerCase()?.includes(this.SNAP_KEY) ? true : false;


    //backend response data.isDiscountedPrice is set true for all promotion plans (oneplan, no-freetrial) even when not actually discounted 
    let isDiscountedPriceAndEndDate = (data?.isDiscountedPrice && data?.discountEndDate) ? true : false;
    //checks to see if the plan is actually discounted
    let isDiscountedPrice = parseFloat(data?.fee) !== data?.regularPlanPrice;

    if (currentPrice?.indexOf(' / ') >= 0) {
      currentPrice.replace(' / ', '/');
    }
    //enrolled in Monthly plan
    if (isMonthlyPlan) {
      if (isDiscountedPrice) {
        if (isPendingAnnualPlan && data?.pendingFee && data?.pendingPricingDetail && data?.pendingRenewalDate) {
          this.setPendingCostDetails(data, currentPrice);
        } else {
          if (isSnapUser) {
            this.subscriptionTypeDetails = '';
            this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_CURRENT_FEE_TAX?.replace('{currentFee}', data?.fee)?.replace('{currentPricingDetails}', this.programDisplayData?.manage?.PLAN_PER_MONTH) || '';
          } else if (isDiscountedPriceAndEndDate) {
            this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_REGULAR_PLAN_PRICE?.replace('{regularPlanPrice}', data?.regularPlanPrice)?.replace('{regularPricingDetails}', this.programDisplayData?.manage?.PLAN_PER_MONTH) || '';
            this.subscriptionTypeDetails = this.programDisplayData?.manage?.CURRENT_PLAN_UNTIL_EXPIRY_DATE?.replace('{currentPrice}', currentPrice)?.replace('{planType}', this.planType)?.replace('{currentExpiryDate}', this.subscriptionService.convertDate(data?.discountEndDate)) || '';
          } else {
            this.subscriptionTypeDetails = '';
            this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_REGULAR_PLAN_PRICE?.replace('{regularPlanPrice}', data?.regularPlanPrice)?.replace('{regularPricingDetails}', this.programDisplayData?.manage?.PLAN_PER_MONTH) || '';
          }
        }
      } else {
        if (isPendingAnnualPlan && data?.pendingFee && data?.pendingPricingDetail && data?.pendingRenewalDate) {
          this.setPendingCostDetails(data, currentPrice);
        } else {
          this.subscriptionTypeDetails = '';
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_CURRENT_FEE_TAX?.replace('{currentFee}', currentPrice)?.replace('{currentPricingDetails}', this.programDisplayData?.manage?.PLAN_PER_MONTH) || '';
        }
      }
      // if the user has just become sheer verified, the new pricing will come as part of pending fee with no pendingSubType
      if (this.snapFlagEnabled && data?.isSheerVerified && data?.pendingFee) {
        let pendingDetails = data?.pendingPricingDetail ? data?.pendingPricingDetail : data?.pricingDetail;
        this.subscriptionTypeDetails = '';
        //Monthly renewal cost text comes as: Auto-renews at $5.99/month(+tax)
        this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_PENDING_FEE_TAX?.replace('{pendingFee}', data?.pendingFee)?.replace('{pendingPricingDetails}', pendingDetails) || '';
      }
    } else {
      //currently enrolled in Annual Plan
      if (isDiscountedPriceAndEndDate && isDiscountedPrice) {
        if (isPendingMonthlyPlan && data?.pendingFee && data?.pendingPricingDetail && data?.pendingRenewalDate) {
          this.setPendingCostDetails(data, currentPrice);
        }
        else if (isSnapUser) {
          this.subscriptionTypeDetails = '';
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_CURRENT_FEE_TAX?.replace('{currentFee}', data?.fee)?.replace('{currentPricingDetails}', this.programDisplayData?.manage?.PLAN_PER_YEAR) || '';
        }
        else {
          this.subscriptionTypeDetails = this.programDisplayData?.manage?.CURRENT_PLAN_PRICE_DETAILS?.replace('{currentPrice}', currentPrice)?.replace('{pricingDetail}', pricingDetail) || '';
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_REGULAR_PLAN_PRICE?.replace('{regularPlanPrice}', data?.regularPlanPrice)?.replace('{regularPricingDetails}', this.programDisplayData?.manage?.PLAN_PER_YEAR) || '';
        }
      } else {
        if ((isPendingMonthlyPlan && data?.pendingFee && data?.pendingPricingDetail && data?.pendingRenewalDate) || 
              (isPendingAnnualPlan && data?.pendingFee && data?.pendingPricingDetail && data?.pendingRenewalDate)) {
          this.setPendingCostDetails(data, currentPrice);
        } else {
          this.subscriptionTypeDetails = '';
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_REGULAR_PLAN_PRICE_TAX?.replace('{regularPlanPrice}', data?.regularPlanPrice)?.replace('{regularPricingDetails}', this.programDisplayData?.manage?.PLAN_PER_YEAR) || '';
        }
      }
      // if the user has just become sheer verified, the new pricing will come as part of pending fee
      if (this.snapFlagEnabled && data?.isSheerVerified && data?.pendingFee) {
        let pendingDetails = data?.pendingPricingDetail ? data?.pendingPricingDetail : data?.pricingDetail;
        pendingDetails = this.subscriptionService.getPricingDetail(pendingDetails, data?.subscriptionType);
        this.subscriptionTypeDetails = '';
        //Annual sheer verification text comes as: Auto-renews at $49/year(+tax)
        if (pendingDetails?.includes(this.programDisplayData?.freshpassData?.forTheFirstYearText)) {
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_PENDING_FEE_FOR_FIRST_YEAR?.replace('{pendingFee}', data?.pendingFee)?.replace('{pendingPricingDetails}', pendingDetails) || '';
        } else {
          this.renewalCostText = this.programDisplayData?.manage?.AUTO_RENEWS_AT_PENDING_FEE_TAX?.replace('{pendingFee}', data?.pendingFee)?.replace('{pendingPricingDetails}', pendingDetails) || '';
        }
      }
    }
    if (data?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_CANCELLATION || data?.subscriptionStatus === this.programDisplayData?.manage?.CANCELLED || data?.subscriptionStatus === this.programDisplayData?.manage?.SUSPENDED?.toUpperCase()) {
      this.renewalCostText = '';
      if (this.isTrialPlan) {
        this.subscriptionTypeDetails = '';
      } else {
        if (isDiscountedPriceAndEndDate) {
          this.subscriptionTypeDetails = this.programDisplayData?.manage?.CURRENT_PLAN_UNTIL_EXPIRY_DATE?.replace('{currentPrice}', currentPrice)?.replace('{planType}', this.planType)?.replace('{currentExpiryDate}', this.currentPlanExpiryDateDisplay)?.replace('{pricingDetail}', pricingDetail) || '';
        } else {
          this.subscriptionTypeDetails = this.programDisplayData?.manage?.CURRENT_PLAN_PRICE_DETAILS?.replace('{currentPrice}', currentPrice)?.replace('{pricingDetail}', pricingDetail) || '';
        }
      }
      if (data?.subscriptionStatus === this.programDisplayData?.manage?.SUSPENDED?.toUpperCase() && data?.isPromoExpired && data?.promoInfo?.includes(this.govAssistanceElibilityText)) {
        this.subscriptionTypeDetails = this.pleaseReverifyEligibilityText || '';
      }
    }
  }

  goToCancelPlan() {
    this.router.navigate([this.programDisplayData?.urlPath?.CANCEL_PLAN_PATH], { state: { userSubscriptionDetails: this.userSubscriptionDetails } });
  }

  getPlanType(): void {
    if (this.userSubscriptionDetails?.subscriptionCode === this.programDisplayData?.code.monthlySubsCode) {
      this.planType = this.programDisplayData?.manage?.MONTHLY;
      this.pendingPlanType = this.programDisplayData?.manage?.ANNUAL;
    } else {
      this.planType = this.programDisplayData?.manage?.ANNUAL;
      this.pendingPlanType = this.programDisplayData?.manage?.MONTHLY;
    }
  } 
}
